import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import SrLink from 'client/components/SrLink/SrLink';
import SrDataTableIndicatorBadge from 'client/components/SrDataTableIndicatorBadge';

class SrAdminNavbarLinks extends Component {
  static propTypes = {
    links: PropTypes.array.isRequired,
    currentLocationPath: PropTypes.string,
    className: PropTypes.string,
  };

  render() {
    const { links, currentLocationPath, className } = this.props;
    return (
      <div className={classnames('admin-navbar-links-container', className)}>
        {links.map(({ id, label, value, indicatorDataTableSource, indicatorViewIds }) => (
          <span className="admin-navbar-link-container" key={`container-${label}-${value}`}>
            <SrLink
              key={`${label}-${value}`}
              to={value}
              className={classnames('admin-navbar-link', id === currentLocationPath && 'active')}
            >
              {(indicatorViewIds || []).map((indicatorViewId) => (
                <SrDataTableIndicatorBadge
                  key={`badge-${indicatorViewId}`}
                  dataTableSource={indicatorDataTableSource}
                  dataTableViewId={indicatorViewId}
                />
              ))}
              {label}
            </SrLink>
          </span>
        ))}
      </div>
    );
  }
}

SrAdminNavbarLinks.displayName = 'SrAdminNavbarLinks';

export default SrAdminNavbarLinks;
